/**
 * Build identity for the web app.
 *
 * `__BUILD_INFO__` is substituted by Vite's `define` at build time (see
 * apps/web/vite.config.ts), so the values below describe the bundle actually
 * being served: version from apps/web/package.json, the commit it was built
 * from, the CI build number, and the build date.
 *
 * It is read lazily rather than captured at module load so tests — and any
 * runtime where the define never ran — can stub it, and so a missing global
 * degrades to placeholders instead of throwing.
 */

export interface BuildInfo {
  version: string;
  build: string;
  commit: string;
  builtAt: string;
}

const FALLBACK: BuildInfo = { version: 'unknown', build: 'dev', commit: 'dev', builtAt: 'unknown' };

export const getBuildInfo = (): BuildInfo => {
  // Read as a bare identifier, not `globalThis.__BUILD_INFO__`: Vite's `define`
  // substitutes the token, and a property access is never rewritten — that
  // silently ships the fallback in production. The typeof guard keeps it safe
  // where the define never ran, and still sees a value assigned to globalThis.
  const defined = typeof __BUILD_INFO__ === 'undefined' ? undefined : __BUILD_INFO__;

  if (!defined || typeof defined !== 'object') return FALLBACK;

  return { ...FALLBACK, ...(defined as Partial<BuildInfo>) };
};
